import { Box } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addFile } from "../customerGroupSetupSlice";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { useRef } from "react";
import CustomButton from "../../../../components/ui/CustomButton";

export default function FileUpload() {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess === 0) setAccess = true;
	else setAccess = false;
	const isRestrictedAccess = setAccess;
	const inputRef = useRef(null);
	const dispatch = useDispatch();
	const cgState = useSelector((store) => store.customerGroupSetup);
	const { files } = cgState;

	function handleInputClick() {
		inputRef.current.click();
	}

	function uploadFile(event) {
    const newFiles = [];
    for (let i = 0; i < event.target.files.length; ++i) {
       const file = event.target.files[i];
       const isDuplicate = files.some(existingFile =>
          existingFile.filePath === file.name
        );
       //console.log(file);
       //dispatch(addFile(file));
       if (!isDuplicate) {
          dispatch(addFile(file));
        }
    }
    if (newFiles.length > 0) {
       newFiles.forEach((file) => dispatch(addFile(file)));
      }	
      // Reset the input field to ensure onChange event fires
      event.target.value = "";
	}

	return (
		<Box>
			<input
				hidden
				type="file"
				multiple={true}
				ref={inputRef}
				onChange={uploadFile}
			/>

			<CustomButton
				startIcon={<AttachmentIcon />}
				sx={{
					ml: "calc(100% - 155px)",
				}}
				disabled={!isRestrictedAccess}
				onClick={handleInputClick}
			>
				Attach File
			</CustomButton>
		</Box>
	);
}
